import { bool } from "prop-types";
import { useCallback } from "react";

import FnrTypography from "FnrTypography";
import { use2FAState } from "Login/TwoFA/API/queryHooks";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";
import { useIsLegacy } from "Login/TwoFA/stateHooks";

import FnrSlides from "UI/FnrSlides";
import FnrTextButton from "UI/FnrTextButton";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

const componentsConfig = [
  {
    key: "noSkip",
    value: ({ isLegacy, noSkipAuthMessage, ...rest }) => (
      <FnrHorizontalGap centered>
        <FnrTypography
          fontSize="xs"
          color="textSecondary"
          type={isLegacy ? undefined : "copy"}
          data-cy="TwoFA_CannotContinueAsGuest"
          {...rest}
        >
          {noSkipAuthMessage}
        </FnrTypography>
      </FnrHorizontalGap>
    ),
  },
  {
    key: "skip",
    value: ({ skipAuth, isLegacy, ...rest }) => (
      <FnrHorizontalGap centered>
        {/* <FnrTextButton
          onClick={skipAuth}
          icon="fa-angle-double-right fas"
          isLegacy={isLegacy}
          iconSide="right"
          data-cy="TwoFA_ContinueAsGuest"
          subtleHover
          {...rest}
        >
          Skip & Continue as Guest
        </FnrTextButton> */}
      </FnrHorizontalGap>
    ),
  },
];

const ContinueAsGuest = () => {
  const { skipAuth: skipAuthRaw, noSkipAuthMessage } = useTwoFAContext();
  const [{ firstFactorType, firstFactor }] = use2FAState();

  const isLegacy = useIsLegacy();

  const activeKey = noSkipAuthMessage ? "noSkip" : "skip";

  const skipAuth = useCallback(() => {
    skipAuthRaw({ firstFactorType, firstFactor });
  }, [firstFactor, firstFactorType, skipAuthRaw]);

  return (
    <FnrSlides
      fullWidth
      activeKey={activeKey}
      clip={false}
      skipAuth={skipAuth}
      isLegacy={isLegacy}
      noSkipAuthMessage={noSkipAuthMessage}
      components={componentsConfig}
    />
  );
};

ContinueAsGuest.propTypes = { show: bool };

export default ContinueAsGuest;
